export const getCurrentAppCode = (search: any) => new URLSearchParams(search).get("app");
